import React from "react";
import { ManageDocketTemplateScreenContext } from "./context";

export const useManageDocketTemplateScreen = () => {
  const context = React.useContext(ManageDocketTemplateScreenContext);
  return context;
};
